import { FC, SVGProps } from 'react'

export const CreateUploadImgBorder: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 101 101"
      width="100%"
      height="100%"
      {...props}
    >
      <rect
        strokeDasharray="5,5"
        strokeWidth="1"
        stroke="rgba(255, 255, 255, 0.20)"
        fill="none"
        ry="4"
        rx="4"
        height="100"
        width="100"
        y="0.5"
        x="0.5"
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  )
}
